/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Edition-tagged fields on core objects.
 *
 * The backend tags some columns of core objects with the industry edition
 * they belong to (leads.re_purpose -> REAL_ESTATE, leads.trip_id -> TRAVEL)
 * and drops them server-side for tenants without that edition. The tags come
 * from GET /module-entitlements (`field_tags`), or the checked-in snapshot
 * until it answers.
 *
 * isFieldVisible(object, column) is true unless the column is tagged and the
 * tenant holds none of its editions. An untagged column is always visible.
 */

import { useCallback } from "react";
import { isFieldVisibleFor } from "../moduleEntitlementMap";
import { useModuleEntitlements } from "./useModuleEntitlements";

export { isFieldVisibleFor };

export function useEditionFields() {
  const { fieldTags, hasEdition, loading } = useModuleEntitlements();

  const isFieldVisible = useCallback(
    (objectApiName, column) => isFieldVisibleFor(fieldTags, hasEdition, objectApiName, column),
    [fieldTags, hasEdition]
  );

  return { isFieldVisible, hasEdition, fieldTags, loading };
}

export default useEditionFields;
